import { render, staticRenderFns } from "./MarketingTitle.vue?vue&type=template&id=13eceeb2&scoped=true"
import script from "./MarketingTitle.vue?vue&type=script&lang=js"
export * from "./MarketingTitle.vue?vue&type=script&lang=js"
import style0 from "./MarketingTitle.vue?vue&type=style&index=0&id=13eceeb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13eceeb2",
  null
  
)

export default component.exports